module.exports = __webpack_public_path__ + "img/iso-pancher.4d053808.svg";